import { FormControl } from '@angular/forms';
import { Component, Input } from '@angular/core';

@Component({
    selector: 'app-upload-content-terms-accept',
    templateUrl: './upload-content-terms-accept.component.html',
    styleUrls: ['./upload-content-terms-accept.component.scss'],
    standalone: false
})
export class UploadContentTermsAcceptComponent {
    @Input() termsAcceptControl!: FormControl<boolean>;
}
